// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:575px){.custom-font-size[data-v-27b9d2e0]{font-size:10px!important}}", ""]);
// Exports
module.exports = exports;
